<div class="row">
  <ng-container>
    <div class="col s12">
      <div class="cards">
        <div class="cards__item" *ngIf="showAdminCard">
          <div class="cards__header">
            <div class="cards__heading">{{ 'apps.admin' | translate }}</div>
            <lms-client-subscription-editor
              *lmsProfileGuard="'subscriptions.actionsMenu'"
              [client]="client"
              [subscription]="subscription"
              [subscriptionRenewal]="subscriptionRenewal"
              (onSave)="onSubscriptionUpdated()"
              (formErrorEmit)="setErrorMessage($event)"
            ></lms-client-subscription-editor>
          </div>
          <div class="cards__block">
            <div>
              <span class="cards__subtitle">{{ 'clients.subscriptions.rateLimit' | translate }}</span>
              <span class="cards__text">{{ subscription ? subscription.rateLimit : '-' }}</span>
            </div>
            <div>
              <span class="cards__subtitle">{{ 'clients.subscriptions.rateRemaining' | translate }}</span>
              <span class="cards__text">{{
                subscription ? subscription.rateLimit - subscription.rateConsumed : '-'
              }}</span>
            </div>
          </div>
          <div class="cards__block">
            <div>
              <span class="cards__subtitle">{{ 'clients.subscriptions.startDate' | translate }}</span>
              <span class="cards__text">{{
                subscription ? (subscription.startDate | lmsDate : client.timezone : 'dd/MM/yyyy') : '-'
              }}</span>
            </div>
            <div>
              <span class="cards__subtitle">{{ 'clients.subscriptions.endDate' | translate }}</span>
              <span class="cards__text">{{
                subscription ? (subscription.endDate | lmsDate : client.timezone : 'dd/MM/yyyy') : '-'
              }}</span>
            </div>
          </div>
          <div class="cards__block">
            <div>
              <span class="cards__subtitle">{{ 'clients.subscriptions.status' | translate }}</span>
              <span class="cards__text">{{
                subscription
                  ? expiredSubscription
                    ? ('clients.subscriptions.expired' | translate)
                    : subscription.active
                    ? ('clients.subscriptions.active' | translate)
                    : ('clients.subscriptions.inactive' | translate)
                  : '-'
              }}</span>
            </div>
          </div>
        </div>
        <div class="cards__item" *lmsProfileGuard="'subscriptions.editorCard'">
          <div class="cards__header">
            <div class="cards__heading">{{ 'apps.editor' | translate }}</div>
            <lms-client-plan-editor
              *lmsProfileGuard="'subscriptions.editor.actionsMenu'"
              [client]="client"
              (onSave)="onPlanChanged($event)"
              (formErrorEmit)="setErrorMessage($event)"
            ></lms-client-plan-editor>
          </div>
          <div class="cards__block">
            <div>
              <span class="cards__subtitle">{{ 'clients.subscriptions.planType' | translate }}</span>
              <span class="cards__text">{{
                client.plan.editorAccess ? ('nouns.plans.' + client.plan.type | translate) : '-'
              }}</span>
            </div>
          </div>
          <div class="cards__block">
            <div>
              <span class="cards__subtitle">{{ 'clients.subscriptions.startDate' | translate }}</span>
              <span class="cards__text">{{
                client.plan.editorAccess ? (client.plan.startDate | lmsDate : client.timezone : 'dd/MM/yyyy') : '-'
              }}</span>
            </div>
            <div>
              <span class="cards__subtitle">{{ 'clients.subscriptions.endDate' | translate }}</span>
              <span class="cards__text">{{
                client.plan.editorAccess ? (client.plan.endDate | lmsDate : client.timezone : 'dd/MM/yyyy') : '-'
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col s12 margin-top" [ngClass]="{ 'display-none': !subscription }">
      <lms-client-subscriptions-list
        [listId]="clientSubscriptionsListId"
        [client]="client"
        [type]="'users'"
      ></lms-client-subscriptions-list>
    </div>
  </ng-container>
</div>
